import axios from 'axios'
import fileDownload from 'js-file-download'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDown } from '@fortawesome/free-solid-svg-icons'

export default function DownloadFile(props) {
  let tiffUrl;
  if (props.fileName === 'spi3') {
    try {
      tiffUrl = require(`../img/Page_1/nowcast/spi3/spi3_${props.date}_01_00.tif`);
    }
    catch (err) {
      alert(err);
    }
  }
  if (props.fileName === 'severity') {
    try {
      tiffUrl = require(`../img/severity/severity_${props.date}_0.tif`);
    }
    catch (err) {
      try {
        tiffUrl = require(`../img/severity/severity_${props.date}_01_00.tif`)
      }
      catch (err) {
        alert(err);
      }
    }
  }
  if (props.fileName === 'Root-zone') {
    try {
      tiffUrl = require(`../img/soil_moist/soil_moist_${props.date}_02_00.tif`);
    }
    catch (err) {
      alert(err);
    }
  } else {
    tiffUrl = require(`../img/Page_1/${props.path}/spi3/spi3_${props.date}_01_00.tif`);
  }
  const handleClick = (url, filename) => {
    axios.get(url, {
      responseType: 'blob',
    })
      .then((res) => {
        fileDownload(res.data, `${filename}.tif`)
      })
  }
  return (
    <div className="">
      <a title={props.name} onClick={() => { handleClick(tiffUrl, props.fileName + props.date) }}>  <img src="https://img.icons8.com/external-others-iconmarket/45/000000/external-tiff-file-types-others-iconmarket.png" /> </a>
      {/* <button className="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded"
       onClick={() => { handleClick(tiffUrl, props.fileName+props.date)}}>
      <FontAwesomeIcon icon={faArrowDown} /> {props.name}</button> */}
    </div>
  );
}